var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:'ebc-btn-' + _vm.size,attrs:{"href":_vm.href ? _vm.href : _vm.signupUrl,"target":"_blank"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }